import bService from '@/api/base-api'
import { CONTRACT_MANAGER_URL } from '@/configs/service-url'

const list = async (agentId) => {
  const agentUrl = CONTRACT_MANAGER_URL.AGENT
  const url = `${agentUrl}/${agentId}/contact-person`
  const result = await bService.get(url)

  return result
}

const create = async (agentId, data) => {
  const agentUrl = CONTRACT_MANAGER_URL.AGENT
  const url = `${agentUrl}/${agentId}/contact-person`
  const result = await bService.post(url, data)

  return result
}

const update = async (agentId, contactPersonId, data) => {
  const agentUrl = CONTRACT_MANAGER_URL.AGENT
  const url = `${agentUrl}/${agentId}/contact-person/${contactPersonId}`
  const result = await bService.put(url, data)

  return result
}

const setPriority = async (agentId, data) => {
  const agentUrl = CONTRACT_MANAGER_URL.AGENT
  const url = `${agentUrl}/${agentId}/contact-person/priority`
  const result = await bService.put(url, data)

  return result
}

const stopSale = async (agentId, contactPersonId, data) => {
  const agentUrl = CONTRACT_MANAGER_URL.AGENT
  const url = `${agentUrl}/${agentId}/contact-person/${contactPersonId}/stop-sale`
  const result = await bService.put(url, data)

  return result
}

const isSecondary = async (agentId, contactPersonId, data) => {
  const agentUrl = CONTRACT_MANAGER_URL.AGENT
  const url = `${agentUrl}/${agentId}/contact-person/${contactPersonId}/is-secondary`
  const result = await bService.put(url, data)

  return result
}

const remove = async (agentId, contactPersonId) => {
  const agentUrl = CONTRACT_MANAGER_URL.AGENT
  const url = `${agentUrl}/${agentId}/contact-person/${contactPersonId}`
  const result = await bService.remove(url)
  return result
}

export default {
  list,
  create,
  update,
  setPriority,
  remove,
  stopSale,
  isSecondary
}
